export default __webpack_public_path__ + "static/media/nwave_logo_bk.0cbdf030.png";